var _a;
import { __extends } from "tslib";
import { CopyPixelTask } from './tasks/webgl/CopyPixelTask';
import { FilterBase } from './FilterBase';
import { ContextGLBlendFactor as BF } from '../base/ContextGLBlendFactor';
import { BlendMode } from '../image/BlendMode';
var DEFAULT_BLEND_MAP = (_a = {},
    _a[''] = [BF.ONE, BF.ONE_MINUS_SOURCE_ALPHA],
    _a[BlendMode.NORMAL] = [BF.ONE, BF.ONE_MINUS_SOURCE_ALPHA],
    _a[BlendMode.LAYER] = [BF.ONE, BF.ONE_MINUS_SOURCE_ALPHA],
    _a[BlendMode.ERASE] = [BF.ZERO, BF.ONE_MINUS_SOURCE_ALPHA],
    _a);
var CopyPixelFilter = /** @class */ (function (_super) {
    __extends(CopyPixelFilter, _super);
    function CopyPixelFilter() {
        var _this = _super.call(this) || this;
        _this._blendDst = BF.ONE_MINUS_SOURCE_ALPHA;
        _this._blendSrc = BF.ONE;
        _this._requireBlend = true;
        _this._blend = '';
        _this._copyPixelTask = new CopyPixelTask();
        _this.addTask(_this._copyPixelTask);
        return _this;
    }
    Object.defineProperty(CopyPixelFilter.prototype, "blendDst", {
        get: function () {
            return this._blendDst;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CopyPixelFilter.prototype, "blendSrc", {
        get: function () {
            return this._blendSrc;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CopyPixelFilter.prototype, "requireBlend", {
        get: function () {
            return this._requireBlend;
        },
        set: function (v) {
            if (!this._requireBlend && v) {
                this.blend = '';
            }
            this._requireBlend = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CopyPixelFilter.prototype, "blend", {
        get: function () {
            return this._blend;
        },
        set: function (v) {
            var map = DEFAULT_BLEND_MAP[v];
            this._requireBlend = !!map;
            if (map) {
                this._blendDst = map[1];
                this._blendSrc = map[0];
            }
            else {
                // go composite by shader
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CopyPixelFilter.prototype, "colorTransform", {
        get: function () {
            return this._copyPixelTask.transform;
        },
        set: function (value) {
            this._copyPixelTask.transform = value;
        },
        enumerable: false,
        configurable: true
    });
    return CopyPixelFilter;
}(FilterBase));
export { CopyPixelFilter };
